module.exports = {
  "name": "@bytel/trilogy-framework",
  "version": "1.18.9",
  "private": false,
  "description": "Trilogy design system for Bouygues Telecom Entreprises",
  "keywords": [
    "bouygues",
    "design system",
    "framework",
    "css"
  ],
  "author": "bouygues-telecom",
  "license": "UNLICENSED",
  "scripts": {
    "fonts": "webpack -c webpack/fonts.js",
    "build": "npm run fonts && webpack",
    "build-default": "npm run fonts && webpack --env theme=default",
    "watch-default": "webpack --watch"
  },
  "devDependencies": {
    "copy-webpack-plugin": "10.0.0",
    "file-loader": "^6.2.0",
    "sass": "^1.34.1",
    "sass-loader": "^12.0.0",
    "stylelint": "^14.1.0",
    "stylelint-config-standard": "^24.0.0",
    "ttf2woff2": "4.0.4",
    "webpack": "^5.64.4",
    "webpack-cli": "^4.9.1",
    "webpack-iconfont-plugin-nodejs": "github:hakaba/webpack-iconfont-plugin-nodejs#1.0.0"
  },
  "engines": {
    "node": ">=14",
    "pnpm": ">=6"
  },
  "files": [
    "framework/src",
    "themes/default/src",
    "themes/common/src",
    "src"
  ],
  "publishConfig": {
    "registry": "https://glouton.int.nbyt.fr/artifactory/api/npm/npm/"
  },
  "dependencies": {
    "@bytel/trilogy-framework": "^1.18.7",
    "dart-sass": "^1.25.0"
  }
}
;